export interface TestimonialVideo {
  url?: string;
  posterUrl?: string;
  durationSec?: number;
}

export interface PublicTestimonial {
  _id: string;
  author: string;
  text?: string;
  country?: string;
  rating: number;
  featured?: boolean;
  video?: TestimonialVideo;
}

/** Limites do vídeo — os mesmos do backend (routes/testimonials.js: ALLOWED_DURATIONS, MAX_VIDEO_BYTES). */
export const VIDEO_DURATION_OPTIONS = [8, 15, 30, 60];
export const VIDEO_DEFAULT_SECONDS = 15;
export const VIDEO_MAX_SECONDS = 60;
export const VIDEO_MAX_MB = 100;
